import { useState } from 'react'
import { api, session } from '../api.js'

export default function Login({ onLogin }) {
  const [email, setEmail] = useState('')
  const [mdp, setMdp] = useState('')
  const [erreur, setErreur] = useState('')

  async function entrer(e) {
    e.preventDefault()
    try {
      const r = await api.login(email, mdp)
      session.setToken(r.token)
      onLogin()
    } catch (err) { setErreur(err.message) }
  }

  return (
    <div className="connexion">
      <form onSubmit={entrer}>
        <p className="marque">UCIVIS</p>
        <h1>Administration</h1>
        {erreur && <p className="erreur" role="alert">{erreur}</p>}
        <label htmlFor="e">Adresse électronique</label>
        <input id="e" type="email" autoComplete="username" value={email}
               onChange={(ev) => setEmail(ev.target.value)} required />
        <label htmlFor="m">Mot de passe</label>
        <input id="m" type="password" autoComplete="current-password" value={mdp}
               onChange={(ev) => setMdp(ev.target.value)} required />
        <button className="btn pri">Se connecter</button>
      </form>
    </div>
  )
}
